// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Layout_wrapper__2dOTA","page-content":"Layout_page-content__1C44z","dark":"Layout_dark__1DNiK","centered":"Layout_centered__r154y"};